import { IProfile, ProfileType } from '@scf-monorepo/interfaces';

export class ProfileHelper {
    public static getActiveProfile(profiles: IProfile[], userGid: string): IProfile {
        if (!profiles?.length) {
            return null;
        }

        const activeProfile = profiles.filter((profile) => profile.isActive);
        return activeProfile[0] || this.getUserProfile(profiles, userGid);
    }

    public static getUserProfile(profiles: IProfile[], userGid: string): IProfile {
        const userProfile = profiles.filter(
            (profile) => profile.type === ProfileType.ORIGINAL && profile.gid === userGid
        );
        if (userProfile?.length >= 2) {
            return userProfile.find((profile) => !profile.scdUser.sponsor) ?? userProfile[0];
        } else {
            return userProfile?.length ? userProfile[0] : null;
        }
    }

    public static formatPhoneNumber(phoneNumber: string): string {
        phoneNumber = phoneNumber?.replace(/-/g, ' ');
        phoneNumber = phoneNumber?.replace(/\(|\)/g, '');
        phoneNumber = phoneNumber?.replace(/\s\s+/g, ' ');
        return phoneNumber;
    }
}
